export { default as NewsSummary } from "./NewsSummary/NewsSummary.vue";
export { default as NewsStory }   from "./NewsStory/NewsStory.vue";
export { default as News }        from "./News.vue";